import select from './BooleanSelect.vue'
const BooleanSelect = {
	install: function(Vue) {
		Vue.component('BooleanSelect', select)
	}
}
export default BooleanSelect
